module.exports = __webpack_public_path__ + "img/phone-screen-ru.c2047a2a.png";